module.exports = __webpack_public_path__ + "static/assets/1cd0fd3dfbafd49fab80ed0dbf8d0ae1.png";